module.exports = __webpack_public_path__ + "static/media/5.Sweden Made Petrol.2b296e9d.jpg";